(function(window, urlServiceFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.urlService = urlServiceFactory(namespace.windowWrapper);
})(this, function(windowWrapper) {
   'use strict';

   /**
    * @memberof TSC
    * @class urlService
    * @classdesc Url opening service.
    */
   var ensureUrlHasValidScheme = function(url) {
      if (typeof url === 'string' && url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
         url = 'http://' + url;
      }
      return url;
   };

   var openUrl = function(url, features) {
      url = ensureUrlHasValidScheme(url);
      if (features) {
         windowWrapper.open(url, features);
      } else {
         windowWrapper.open(url);
      }
   };

   var isUrlAbsolute = function(url) {
      return url.indexOf('http://') === 0 || url.indexOf('https://') === 0;
   };

   var generateQueryStringWithExtraParam = function(key, value) {
      key = encodeURI(key);
      value = encodeURI(value);

      var windowLocation = windowWrapper.getLocation();
      var kvp = windowLocation.search.substr(1).split('&');

      var i = kvp.length;
      var x;
      while (i--) {
         x = kvp[i].split('=');

         if (x[0] === key) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
         }
      }

      if (i < 0) {
         kvp[kvp.length] = [key, value].join('=');
      }

      var query = kvp.join('&');
      if (query.startsWith('&')) {
         query = query.substr(1);
      }

      return '?' + query;
   };

   var generateCurrentUrlWithExtraQueryParam = function(paramName, paramValue) {
      var search = generateQueryStringWithExtraParam(paramName, paramValue);
      var windowLocation = windowWrapper.getLocation();
      var port = windowLocation.port ? ':' + windowLocation.port : '';
      return windowLocation.protocol + '//' + windowLocation.hostname + port + windowLocation.pathname + search + windowLocation.hash;
   };

   return {
      openUrl: openUrl,
      isUrlAbsolute: isUrlAbsolute,
      generateCurrentUrlWithExtraQueryParam: generateCurrentUrlWithExtraQueryParam
   };
});
